import { BaseResource } from "./BaseResource";
import { apiResourceUrl } from "@ploy-lib/core";
class VendorResource extends BaseResource {
    pk() {
        return this.customerId.toString();
    }
}
VendorResource.urlRoot = apiResourceUrl("vendors");
export { VendorResource };
//# sourceMappingURL=VendorResource.js.map